import { render, staticRenderFns } from "./PromotionCompletionRate.vue?vue&type=template&id=667d54d2&scoped=true"
import script from "./PromotionCompletionRate.vue?vue&type=script&lang=ts"
export * from "./PromotionCompletionRate.vue?vue&type=script&lang=ts"
import style0 from "./PromotionCompletionRate.vue?vue&type=style&index=0&id=667d54d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d54d2",
  null
  
)

export default component.exports